import { Box, Skeleton } from '@mui/material';

const CallSummaryContentSkeleton = () => {
  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          width: '100%',
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'grey.300',
          borderRadius: 1,
        }}
      >
        {/* Call Summary Section */}
        <Box sx={{ p: 3 }}>
          <Skeleton variant="text" width={150} height={32} sx={{ mb: 2 }} />
          <Skeleton variant="text" width="100%" />
          <Skeleton variant="text" width="100%" />
          <Skeleton variant="text" width="80%" />
        </Box>

        <Box
          sx={{
            display: 'flex',
            flex: 1,
            width: '100%',
          }}
        >
          {/* Key Details Section */}
          <Box
            sx={{
              width: '50%',
              p: 3,
            }}
          >
            <Skeleton variant="text" width={150} height={32} sx={{ mb: 3 }} />
            {[...Array(4)].map((_, index) => (
              <Box key={index} sx={{ mb: 2 }}>
                <Skeleton variant="text" width="90%" />
              </Box>
            ))}
          </Box>

          {/* Behavior Analysis Section */}
          <Box sx={{ width: '50%', p: 3 }}>
            <Skeleton variant="text" width={150} height={32} sx={{ mb: 3 }} />
            <Box>
              {/* Table Header */}
              <Box sx={{ mb: 1 }}>
                <Skeleton variant="rectangular" height={40} />
              </Box>
              {/* Table Rows */}
              {[...Array(3)].map((_, index) => (
                <Box key={index} sx={{ mb: 1 }}>
                  <Skeleton variant="rectangular" height={52} />
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CallSummaryContentSkeleton;
